"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _helpers = require("react-platform-components/dist/helpers");
var _config = require("../config");
var _lodash = _interopRequireDefault(require("lodash"));
var _LoadingPage = require("react-platform-components/dist/components/LoadingPage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = function _default(props) {
  var products = props.products,
    openConfirmDialog = props.openConfirmDialog;
  if (_lodash.default.isEmpty(products)) {
    return /*#__PURE__*/_react.default.createElement(_LoadingPage.LoadingPage, null);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    style: {
      margin: '1rem'
    },
    container: true,
    spacing: 4
  }, products.map(function (bookmark, index) {
    var image = bookmark.store.logo && bookmark.store.logo.original ? (0, _helpers.joinPaths)(_config.BASE_URL, bookmark.store.logo.original) : "".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png");
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: index,
      item: true,
      md: 3,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Card, null, /*#__PURE__*/_react.default.createElement("a", {
      href: "".concat(_config.BASE_URL).concat(_config.STORES_ENDPOINT, "/").concat(bookmark.store.id),
      target: "_blank",
      rel: "noopener noreferrer",
      className: "no-underline"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
      style: {
        height: 200
      },
      image: image
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      style: {
        position: 'absolute'
      },
      item: true,
      container: true,
      alignItems: "center",
      justify: "flex-end"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: function onClick(event) {
        event.preventDefault();
        openConfirmDialog(bookmark)();
      },
      className: "hover:text-white z-10"
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "favorite"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      alignItems: "center",
      xs: 10
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: "font-medium text-lg leading-none",
      variant: "overline"
    }, bookmark.store.name)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      style: {
        height: 'auto'
      },
      className: "text-gray-700",
      variant: "body2"
    }, _lodash.default.truncate(bookmark.store.description, {
      length: '80'
    }))))))))));
  }));
};
exports.default = _default;